/**
 * 작업문서 사진 업로드
 *
 * DiaryPhotoBase 상속 — ℹ 토글 안내 + 4컬럼 그리드(＋ 업로드 셀)
 *
 * [격자 모드의 등록된 서류 사진 줄]  전체허용(격자 인라인)에서는 기존 패널을 그리지 않아 등록된 서류 사진이 시트 안에
 *   보이지 않았다(3.21 출시 2026-10-26). 현장사진(DiaryJobs)과 같은 「등록된 사진」 줄(.dph-reg)을 격자 위에 그린다 —
 *   태그 없이 장수·썸네일(탭 → 뷰어)만. 등록(order:jobphoto:changed phototype=1)·삭제(gallery:delete) 때 그 줄만 다시 읽는다.
 */
import DiaryPhotoBase from './DiaryPhotoBase';
import Util from '../../Common/Util';

export default class DiaryDocs extends DiaryPhotoBase {
    get pfx()           { return 'dd'; }
    get uploadTag()     { return 'diary2'; }
    get uploadContext() { return 'diaryDocs'; }
    get maxSheet()      { return 5; }

    _loadUrl(ordernum)  { return `/m/ajax/order/${ordernum}/job-photos?phototype=1`; }
    _addUrl(ordernum)   { return `/m/ajax/order/${ordernum}/job-photos/add`; }
    _addParams(file)    {
        return {
            img_id: file.id,
            phototype: 1,
            file_date: file.date || '',
            file_gps: file.gps || '',
            gps_address: file.address || '',
        };
    }

    _deleteRequest(ordernum, photoNum) {
        $.ajax({ type: 'DELETE', url: `/m/ajax/order/${ordernum}/photos`, data: { deletenum: photoNum } });
    }

    init() {
        // 피커 지원 앱이면 '＋업로드' 단계 없이 격자를 허브 탭 안에 바로 인라인으로 띄운다.
        // 미지원(옛앱·PC)이면 기존 패널(＋업로드 → 네이티브 업로드)을 그대로 쓴다.
        if ($j.F.App.pickerSupported()) { this._openInlinePicker(); return; }
        this.loadExisting();
    }

    /** 허브 탭 본문에 DevicePicker 격자를 인라인으로 로드 (pickFiles 의 BS 버전과 같은 설정) */
    _openInlinePicker() {
        const ordernum = this._ordernum();
        const childId = `${this.id}-ddp`;
        // 위: 등록된 서류 사진 줄(.dph-reg) / 아래: 격자 — 현장사진(DiaryJobs._openInlinePicker)과 같은 구조
        $(`#${this.id}`).html(`
            <div class="dph-inline">
                <div class="dph-reg" style="display:none"></div>
                <div id="${childId}" class="dph-inline-picker"></div>
            </div>`);
        $j.Ui.Div.open({
            id: childId,
            target: '$j.Ui.DevicePicker',
            container: this,
            data: {
                uploadId:  ordernum,
                uploadTag: this.uploadTag,   // 'diary2'
                categories: [],              // 작업문서는 분류 칩 없음
                title:     '작업문서',
                max:       this.maxSheet,
                maxSheet:  this.maxSheet,
                onCommit:  (files) => this.commitGridPhotos(files),
                onClose:   () => $j.Ui.BS.close(),   // 인라인 '닫기' → 사진 허브 시트 전체 닫기
                onNotFull: (perm) => this._showLegacyPane(perm), // 부분·거부 → 기존 그리드 패널 + 배너로 전환
                backClose: true,   // 사진 전체 허용 격자 — 뒤로가기로 크게 보기·시트를 한 겹씩 닫는다(일지 화면을 벗어나지 않게)
            },
        });
        this._initRegBarHandler();
        this._loadRegBar();
    }

    /** 격자 모드 전용 핸들러 — initHandler(기존 패널)는 격자 모드에서 불리지 않는다. _showLegacyPane 이 off() 하고 initHandler 가 다시 건다 */
    _initRegBarHandler() {
        const $el = $(`#${this.id}`);
        const self = this;

        $el.on('click', '.dph-reg-th', function () {
            self.openViewer(parseInt($(this).data('idx'), 10));
        });
        $el.on('click', '.dph-reg-fold', function () {
            self._regFolded = !self._regFolded;
            $el.find('.dph-reg').toggleClass('is-folded', self._regFolded);
            $(this).text(self._regFolded ? '펼치기 ▾' : '접기 ▴');
        });

        // 격자 커밋(촬영·사진 추가)으로 작업문서(phototype=1)가 바뀜 → 줄 다시 읽기
        $j.Common.EventBus.on($j.getNS(this), 'order:jobphoto:changed', (e, payload) => {
            const { ordernum, phototype } = payload || {};
            if (String(ordernum) !== String(self._ordernum())) return;
            if (parseInt(phototype, 10) !== 1) return;
            self._loadRegBar();
        });
        // 뷰어 삭제 (Gallery 가 서버 삭제까지 처리) → 풀에서만 빼고 줄 갱신
        $j.Common.EventBus.on($j.getNS(this), 'gallery:delete', (e, payload) => {
            const { ordernum, img_id } = payload || {};
            if (String(ordernum) !== String(self._ordernum())) return;
            const idx = self.pool.findIndex(p => String(p.id) === String(img_id));
            if (idx === -1) return;
            self.pool.splice(idx, 1);
            self._renderRegBar();
        });
    }

    /** 등록된 서류 사진을 다시 읽어 줄만 그린다 (reloadPool 은 기존 패널용이고 목록이 비면 그리지 않아 0장 안내를 못 띄운다) */
    _loadRegBar() {
        const self = this;
        if (!$(`#${this.id}`).length) return;
        const seq = this._regSeq = (this._regSeq || 0) + 1;   // 마지막 요청의 답만 그린다 (DiaryJobs.refreshSlots 와 같은 이유)
        $.ajax({
            type: 'GET', url: this._loadUrl(this._ordernum()),
            success(r) {
                if (self._dead) return;   // 탭이 바뀐 뒤 도착한 응답 — 같은 자리에 다른 탭이 그려져 있다
                if (seq !== self._regSeq) return;
                if (!r || !r.result) return;
                self.pool = self._parseList(Array.isArray(r.list) ? r.list : []);
                self._renderRegBar();
            },
        });
    }

    /** 등록된 서류 사진 줄 — 「등록된 서류 사진 N장」 + 썸네일(탭 → 뷰어). 지난 렌더에 없던 id 는 「방금」 표시 */
    _renderRegBar() {
        const $bar = $(`#${this.id}`).find('.dph-reg');
        if (!$bar.length) return;
        const prev = this._regIds;                                       // 첫 렌더 전엔 undefined → 「방금」 없음
        this._regIds = new Set(this.pool.map(p => String(p.id)));

        if (!this.pool.length) {
            $bar.html(`
                <div class="dph-reg-h"><span class="dph-reg-title">등록된 서류 사진이 아직 없어요</span></div>
                <p class="dph-reg-empty">촬영하거나 아래 최근 사진에서 골라 추가하면 여기에 보여요</p>`)
                .removeClass('is-folded').show();
            return;
        }
        const thumbs = this.pool.map((p, idx) => {
            const isNew = !!(prev && !prev.has(String(p.id)));
            return `
                <div class="dph-reg-th${isNew ? ' is-new' : ''}" data-idx="${idx}" role="button" aria-label="서류 사진 크게 보기">
                    <img src="${p.thumbUrl}" alt="">
                    ${isNew ? '<span class="dph-reg-just">방금</span>' : ''}
                </div>`;
        }).join('');
        $bar.html(`
            <div class="dph-reg-h">
                <span class="dph-reg-title">등록된 서류 사진 <b>${this.pool.length}</b>장</span>
                <button type="button" class="dph-reg-fold">${this._regFolded ? '펼치기 ▾' : '접기 ▴'}</button>
            </div>
            <div class="dph-reg-row">${thumbs}</div>
            <div class="dph-reg-hint">탭하면 크게 보기 · 삭제는 크게 보기 화면에서</div>`)
            .toggleClass('is-folded', !!this._regFolded).show();
    }

    /**
     * 부분·거부 권한 — 디바이스 격자 대신 기존 작업문서 패널(등록사진 그리드 + ＋업로드)로 전환하고 상단에 권한 배너.
     * ＋업로드는 네이티브 업로드로 처리한다 (권한 없이도 됨).
     */
    _showLegacyPane() {
        this._notFull = true;                 // draw 배너 + pickFiles 네이티브 분기용
        $j.Ui.Div.destroyByContainer(this);   // 인라인 격자(DevicePicker) 파괴
        $(`#${this.id}`).off();                                   // 격자 모드 핸들러(등록된 사진 줄) 해제 — initHandler 가 다시 건다
        $j.Common.EventBus.offNamespace($j.getNS(this));
        this.loadExisting();                  // 기존 그리드 패널 렌더 (draw 가 _notFull 배너 포함)
    }

    /**
     * 업로드 셀 → 디바이스 사진 그리드 피커 (현장사진과 동일 UX).
     *
     * 작업문서는 분류 칩이 없으므로 categories 를 비워 칩 행을 숨긴다.
     * BS 싱글톤이라 피커가 DiaryPhotoHub 를 파괴하므로, 커밋 후 돌아올 허브 옵션을 함께 넘긴다.
     * 구앱·권한거부 시의 네이티브 피커 폴백은 DevicePicker 안에서 처리한다.
     */
    pickFiles() {
        const ordernum = this._ordernum();
        const hubData = Object.assign({}, this.parent?.data || {}, { ordernum, tab: 'doc' });

        // 격자(전체허용) / 네이티브 폴백(_notFull·옛앱·PC) 판정·분기는 Upload.pickPhotos 공용 헬퍼가 처리
        $j.F.Upload.pickPhotos({
            notFull: this._notFull,
            native: { tag: this.uploadTag, context: this.uploadContext, max_sheet: this.maxSheet, id: ordernum },
            grid: {
                uploadId:   ordernum,
                uploadTag:  this.uploadTag,   // 'diary2'
                categories: [],               // 칩 없음
                title:      '작업문서',
                max:        this.maxSheet,   // 현장사진과 같은 이유 — 무제한 선택 시 동시 POST 폭주
                maxSheet:   this.maxSheet,
                // 작업문서 커밋(job-photos, phototype=1)은 도메인 로직이라 피커에 넣지 않고 여기서 주입한다
                onCommit:   (files) => this.commitGridPhotos(files),
                hub: { target: '$j.F.Diary.DiaryPhotoHub', fixedHeight: true, data: hubData },
            },
        });
    }

    /** 그리드 피커가 업로드한 파일을 작업문서(phototype=1)로 커밋. 커밋 시 인스턴스는 파괴돼 있어 이벤트로만 알린다. */
    commitGridPhotos(files) {
        const ordernum = this._ordernum();
        const list = (files || []).filter(f => f && f.id);
        if (!list.length) return Promise.resolve();

        let ok = 0, fail = 0;
        const posts = list.map(file => Promise.resolve($.post(this._addUrl(ordernum), this._addParams(file)))
            .then(r => { r && r.result ? ok++ : fail++; }, () => { fail++; }));

        return Promise.all(posts).then(() => {
            if (ok > 0) {
                $j.Common.EventBus.trigger('order:jobphoto:changed', { ordernum, phototype: 1, count: ok });
                $j.Ui.Toast.show('success', `사진 ${ok}장을 등록했습니다.`);
            }
            if (fail > 0) $j.Ui.Toast.show('warning', `사진 ${fail}장 등록에 실패하였습니다.`);
        });
    }

    _initExtraHandlers() {
        // 그리드 피커가 작업문서를 커밋했을 때 — 목록 재동기화
        $j.Common.EventBus.on($j.getNS(this), 'order:jobphoto:changed', (e, payload) => {
            const { ordernum, phototype } = payload || {};
            if (String(ordernum) !== String(this._ordernum())) return;
            if (parseInt(phototype, 10) !== 1) return;
            this.reloadPool();
        });
    }

    _parseList(list) {
        return list.map(p => ({
            photoNum: p.num,
            id: p.img_id,
            host: p.host,
            path: p.path,
            thumbUrl: Util.getImageUrl(p.path, p.host, 'x100'),
            isConfirm: p.is_confirm == 1,
            assignedTo: null,
        }));
    }

    /** 부분·거부 권한 안내 배너 (기존 패널 상단) — '사진 접근 허용' 누르면 전체접근 요청 */
    _permBannerHtml() {
        return `
        <div class="dph-perm-banner">
            <div class="dph-perm-banner-txt">
                <b>⚠️ 사진 접근이 제한돼 있어요.</b>
                <span>전체 허용하면 최근 사진을 바로 골라 올릴 수 있어요. 지금은 아래 '＋업로드'로 올릴 수 있습니다.</span>
            </div>
            <button type="button" class="dph-perm-banner-btn">사진 접근 허용</button>
        </div>`;
    }

    /** 새 디자인: ℹ 안내 + 그리드(＋ 셀) */
    draw() {
        const html = `
        <div class="dph-pane">
            ${this._notFull ? this._permBannerHtml() : ''}
            <div class="dph-info-row">
                <button class="dph-info-btn dd-info-btn" type="button" aria-label="안내">
                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                        <circle cx="6.5" cy="6.5" r="5.5" stroke="var(--color-text-secondary)" stroke-width="1.2"/>
                        <text x="6.5" y="10" text-anchor="middle" font-size="8" font-weight="700" fill="var(--color-text-secondary)">i</text>
                    </svg>
                </button>
            </div>
            <div class="dph-info-box dd-info-box" style="display:none;">
                ⭐ 수주포인트 10점<br>
                · 작업확인서 및 영수증 등 서류 1장 이상<br>
                · 삭제 시 포인트가 환원될 수 있습니다.
            </div>
            <div class="dph-photo-grid" id="${this.pfx}-grid"></div>
            ${this.isPC ? '<div class="mc-dropzone">이미지를 여기에 드래그앤드롭</div>' : ''}
        </div>`;

        $(`#${this.id}`).html(html);
        this.refresh();
    }

    initHandler() {
        super.initHandler();
        const $el = $(`#${this.id}`);
        const self = this;
        $el.on('click', '.dd-info-btn', function () {
            const $btn = $(this);
            const $box = $el.find('.dd-info-box');
            const isOpening = $box.is(':hidden');
            $box.slideToggle(180);
            $btn.toggleClass('on', isOpening);
        });

        // 권한 배너 '사진 접근 허용' — 전체접근 요청. 전체가 되면 허브를 다시 열어 격자로 복귀한다.
        $el.on('click', '.dph-perm-banner-btn', function () {
            self._awaitingPerm = true;
            if (!$j.F.App.listPhotos({ reselect: true })) {
                self._awaitingPerm = false;
                $j.Ui.Toast.show('warning', '이 버전에서는 사진 권한 재요청을 지원하지 않습니다.');
            }
        });
        // 권한 재요청 응답 — 전체(full)면 허브 재오픈(→ 격자). 아니면 기존 패널 유지.
        $j.Common.EventBus.on($j.getNS(this), 'app:photos', (e, d) => {
            if (!self._awaitingPerm) return;
            self._awaitingPerm = false;
            if (d && d.permission === 'full') {
                $j.Ui.BS.open({ target: '$j.F.Diary.DiaryPhotoHub', fixedHeight: true,
                    data: Object.assign({}, self.parent?.data || {}, { ordernum: self._ordernum(), tab: 'doc' }) });
            }
        });
    }

    /** 항상 그리드 표시 — wrap 토글 불필요 */
    refresh() {
        this.renderGrid();
    }

    renderGrid() {
        const $g = $(`#${this.id}`).find(`#${this.pfx}-grid`).empty();
        this.pool.forEach((p, idx) => {
            const thumb = p.thumbUrl || Util.getImageUrl(p.path, p.host, 'x100');
            $g.append(`
                <div class="dph-grid-cell mc-grid-cell" data-idx="${idx}">
                    <img src="${thumb}" alt="">
                </div>`);
        });
        $g.append(`
            <div class="dph-add-cell mc-pool-upload-btn" role="button" aria-label="사진 업로드">
                <span class="dph-add-plus">+</span>
                <span class="dph-add-label">업로드</span>
            </div>`);
    }
}